module.exports = __webpack_public_path__ + "img/banner_xxjs.8686bc5b.png";